export default __webpack_public_path__ + "static/media/design_concepts.ccbb5949.svg";